import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const TEACHER_REPORTS_ROUTE = {
  name: 'reports',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },
  DEFAULT: '',

  REPORTS_ACTIVITY: {
    name: ':activityId',
    route(classId: string, activityId: string): string[] {
      return [...TEACHER_ROUTE.REPORTS.route(classId), activityId];
    }
  }
};